export default class ColorRgbError extends Error {
	name = 'ColorRgbError';
}
